import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import moment from 'moment'

//Base Components
import '@/baseComponents'

import i18n from './i18n'

//Mixins

// Config
axios.defaults.baseURL = process.env.VUE_APP_NOLA_URI;
//axios.defaults.headers.common['Authorization'] = process.env.VUE_APP_NOLA_AUTH_TOKEN;
Vue.config.productionTip = false
Vue.prototype.$http = axios;
Vue.prototype.moment = moment
moment.locale("de")



new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
